import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "@/lib/apiClient";
import { trackPurchase } from "@/lib/analytics";
import { CheckCircle, XCircle, CircleNotch } from "@phosphor-icons/react";

export function PaymentSuccessPage() {
  const navigate = useNavigate();
  const [msg, setMsg] = useState("Confirming your payment…");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setFailed(true); setMsg("Missing session."); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const r = await apiClient.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          trackPurchase(r.data.purchase);  // success-only, deduped per transaction_id
          setMsg("Payment confirmed! Redirecting…");
          const dest = r.data.kind && r.data.kind !== "rewrite"
            ? "/account?billing=1"
            : `/review/${r.data.proposal_id}?paid=1`;
          setTimeout(() => navigate(dest), 1200);
          return;
        }
        if (["expired", "failed"].includes(r.data.payment_status) || attempts > 15) {
          setFailed(true); setMsg("We couldn't confirm the payment."); return;
        }
        setTimeout(poll, 2000);
      } catch {
        if (attempts > 15) { setFailed(true); setMsg("We couldn't confirm the payment."); }
        else setTimeout(poll, 2000);
      }
    };
    poll();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] grain p-6">
      <div className="text-center" data-testid="payment-success">
        {failed ? <XCircle size={54} className="mx-auto text-red-500" weight="fill" />
          : msg.startsWith("Payment confirmed") ? <CheckCircle size={54} className="mx-auto text-emerald-500" weight="fill" />
          : <CircleNotch size={54} className="mx-auto text-slate-400 animate-spin" />}
        <h1 className="font-display font-black text-2xl tracking-tighter text-[#0F172A] mt-5">{msg}</h1>
        {failed && <button onClick={() => navigate("/")} className="mt-6 h-10 px-5 bg-[#0F172A] text-white rounded-md text-sm font-semibold">Back to dashboard</button>}
      </div>
    </div>
  );
}

export function PaymentCancelPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] grain p-6">
      <div className="text-center" data-testid="payment-cancel">
        <XCircle size={54} className="mx-auto text-slate-400" weight="fill" />
        <h1 className="font-display font-black text-2xl tracking-tighter text-[#0F172A] mt-5">Payment cancelled</h1>
        <p className="text-slate-500 mt-2">No charge was made.</p>
        <button onClick={() => navigate("/")} className="mt-6 h-10 px-5 bg-[#0F172A] text-white rounded-md text-sm font-semibold">Back to dashboard</button>
      </div>
    </div>
  );
}
